// 仅新增可选排版，主内容仍取原文本实例已经解析好的 dataChart.value。
const text = (value, fallback = '') => typeof value === 'string' ? value : fallback
function number (value, fallback, min, max) {
  if ((typeof value !== 'number' && typeof value !== 'string') || String(value).trim() === '') return fallback
  const parsed = Number(value)
  return Number.isFinite(parsed) ? Math.max(min, Math.min(max, parsed)) : fallback
}

export function textMetricSettings (option = {}) {
  return {
    title: text(option.metricTitle, '指标名称'),
    suffix: text(option.metricSuffix),
    description: text(option.metricCaption),
    titleSize: number(option.metricTitleSize, 14, 1, 200),
    titleColor: text(option.metricTitleColor, '#d9efff'),
    suffixSize: number(option.metricSuffixSize, 14, 1, 200),
    suffixColor: text(option.metricSuffixColor, '#d9efff'),
    suffixGap: number(option.metricSuffixGap, 6, 0, 200),
    descriptionSize: number(option.metricCaptionSize, 12, 1, 200),
    descriptionColor: text(option.metricCaptionColor, '#8daec3'),
    rowGap: number(option.metricRowGap, 4, 0, 200)
  }
}

export function textMetricStyles (option = {}) {
  const settings = textMetricSettings(option)
  const align = ['left', 'center', 'right'].includes(option.textAlign) ? option.textAlign : 'left'
  const ellipsis = { minWidth: '0', maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }
  return {
    root: { width: '100%', height: '100%', boxSizing: 'border-box', display: 'flex', flexDirection: 'column',
      justifyContent: 'center', alignItems: { left: 'flex-start', center: 'center', right: 'flex-end' }[align],
      gap: settings.rowGap + 'px', overflow: 'hidden', textAlign: align, textDecoration: 'none',
      fontFamily: text(option.fontFamily, 'Microsoft YaHei'), backgroundColor: text(option.backgroundColor, 'transparent') },
    title: { ...ellipsis, fontSize: settings.titleSize + 'px', color: settings.titleColor, lineHeight: '1.35', fontWeight: '500' },
    row: { display: 'flex', alignItems: 'baseline', columnGap: settings.suffixGap + 'px', minWidth: '0', maxWidth: '100%' },
    value: { ...ellipsis, fontSize: number(option.fontSize, 32, 1, 200) + 'px', color: text(option.color, '#72edff'),
      fontWeight: option.fontWeight || 'bold', letterSpacing: number(option.split, 0, 0, 100) + 'px', lineHeight: '1.1' },
    suffix: { ...ellipsis, flexShrink: '0', fontSize: settings.suffixSize + 'px', color: settings.suffixColor, lineHeight: '1.35' },
    description: { ...ellipsis, fontSize: settings.descriptionSize + 'px', color: settings.descriptionColor, lineHeight: '1.35', fontWeight: 'normal' }
  }
}

function metricContent (vm, h) {
  const option = vm.option || {}, settings = textMetricSettings(option), styles = textMetricStyles(option)
  const value = vm.dataChart && vm.dataChart.value
  const content = value === undefined || value === null ? '—' : typeof value === 'object' ? JSON.stringify(value) : String(value)
  const children = []
  if (settings.title) children.push(h('div', { class: 'screen-text-metric__title', style: styles.title, attrs: { title: settings.title } }, [settings.title]))
  const row = [h('span', { class: 'screen-text-metric__value', style: styles.value, attrs: { title: content } }, [content])]
  if (settings.suffix) row.push(h('span', { class: 'screen-text-metric__suffix', style: styles.suffix }, [settings.suffix]))
  children.push(h('div', { class: 'screen-text-metric__row', style: styles.row }, row))
  if (settings.description) children.push(h('div', { class: 'screen-text-metric__description', style: styles.description, attrs: { title: settings.description } }, [settings.description]))
  return h(option.link ? 'a' : 'div', { ref: 'text', class: 'screen-text-metric', style: styles.root,
    attrs: option.link ? { href: vm.linkHref, target: vm.linkTarget } : {} }, children)
}

// 沿用旧 Avue 实例、根节点事件与尺寸；编辑、预览、分享及实时数据共用同一排版。
export function installTextMetricRuntime (Vue) {
  if (Vue.__textMetricRuntime) return
  Vue.__textMetricRuntime = true
  Vue.mixin({
    beforeCreate () {
      if (this.$options.name !== 'avue-echart-text' || !this.$options.render) return
      const original = this.$options.render, move = this.$options.methods && this.$options.methods.move
      this.$options.render = function (...args) {
        const node = original.apply(this, args)
        if (!this.option || this.option.textPresentation !== 'metric' || !node) return node
        node.children = [metricContent(this, args[0] || this.$createElement)]
        return node
      }
      if (move) this.$options.methods = { ...this.$options.methods, move (...args) {
        if (this.option && this.option.textPresentation === 'metric') { clearInterval(this.check); this.left = 0; return }
        return move.apply(this, args)
      } }
    },
    created () {
      if (this.$options.name !== 'avue-echart-text' || !this.move) return
      this.$watch(() => this.option && this.option.textPresentation, () => this.move())
    }
  })
}
